import React from 'react';
import '../scss/account-action-modal.style.scss';

interface DeactivateAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeactivateAccountModal: React.FC<DeactivateAccountModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    // TODO: Add API call for account deactivation
    onConfirm();
  };

  return (
    <div className="account-action-modal-overlay" onClick={onClose}>
      <div className="account-action-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">Deactivate account</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#252525"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="modal-message">
            <p>Your account will be paused, and you won't be able to access any features.</p>
            <p>
              You'll have 6 months to reactivate it — after that, your data may be permanently
              deleted.
            </p>
            <p>This action is reversible within 6 months.</p>
          </div>

          <button className="modal-action-btn" onClick={handleConfirm}>
            <span>Yes, deactivate my account</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateAccountModal;
